import { UseQueryOptions, UseQueryResult, useQuery } from 'react-query';

import { VoiceboxResponseAction } from 'bones/constants/voicebox/message';
import { requestStardogVoiceboxAnalysis } from 'bones/utils/voicebox/request';

const requestPortalVoiceboxAnalysis =
  (
    connectionId: string,
    conversationId: string,
    messageId: string,
    context: Record<string, any>,
    analysis: string
  ) =>
  async () => {
    if (!connectionId || !conversationId || !messageId || !analysis) {
      return null;
    }

    try {
      const analysisResponse = await requestStardogVoiceboxAnalysis({
        connectionId,
        conversationId,
        messageId,
        context,
        analysis,
      });

      if (analysisResponse.error) {
        throw new Error(analysisResponse.error);
      }

      return {
        messageId,
        analysis,
        actions: (analysisResponse.actions as VoiceboxResponseAction[]) || [],
        result: analysisResponse.result || '',
      };
    } catch (err) {
      return {
        messageId,
        analysis,
        error: (err as Error).message,
      };
    }
  };

export const usePortalVoiceboxAnalysis = (
  connectionId: string,
  connectionIdx: number,
  conversationId: string,
  messageId: string,
  context: Record<string, any>,
  analysis: string,
  options?: UseQueryOptions<
    | {
        messageId: string;
        analysis: string;
        actions: VoiceboxResponseAction[];
        result: string;
        error?: never;
      }
    | {
        messageId: string;
        analysis: string;
        actions?: never;
        result?: never;
        error: string;
      }
    | null
  >
): UseQueryResult<
  | {
      messageId: string;
      analysis: string;
      actions: VoiceboxResponseAction[];
      result: string;
      error?: never;
    }
  | {
      messageId: string;
      analysis: string;
      actions?: never;
      result?: never;
      error: string;
    }
  | null
> => {
  return useQuery<
    | {
        messageId: string;
        analysis: string;
        actions: VoiceboxResponseAction[];
        result: string;
        error?: never;
      }
    | {
        messageId: string;
        analysis: string;
        actions?: never;
        result?: never;
        error: string;
      }
    | null
  >(
    `usePortalVoiceboxAnalysis-${
      connectionId ? connectionIdx : null
    }-${conversationId}-${messageId}-${analysis}`,
    requestPortalVoiceboxAnalysis(
      connectionId,
      conversationId,
      messageId,
      context,
      analysis
    ),
    options
  );
};
